import { Icon, IconsEnum } from 'components/Icons';

import { ItemWithTranslation } from 'types/swagger';
import styles from './ScommesseFiltersHeaderSticky.module.scss';
import { useTranslation } from 'hooks/useLingUI';

export type ScommesseFiltersHeaderStickyProps = ItemWithTranslation<{
  text: string;
  selectedFilter: string;
}> & {
  isPreferito?: boolean;
  hasAdditionalFilters?: boolean;
  secondaryFiltersOpen?: boolean;
  containerClassName?: string;
  textSecondary?: string;
  handleOpenPrimaryFilters: React.Dispatch<React.SetStateAction<boolean>>;
  handleOpenSecondaryFilters?: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ScommesseFiltersHeaderSticky = ({
  text,
  textTrKey,
  selectedFilter,
  selectedFilterTrKey,
  isPreferito,
  textSecondary,
  hasAdditionalFilters,
  secondaryFiltersOpen,
  containerClassName,
  handleOpenPrimaryFilters,
  handleOpenSecondaryFilters,
}: ScommesseFiltersHeaderStickyProps) => {
  // TODO selectedFilter da redux ?

  const { t } = useTranslation();

  return (
    <div className={`${styles.container} ${containerClassName ? containerClassName : ''}`}>
      <button
        type="button"
        className={styles.primaryFiltersBtn}
        // TODO dispatch open filters
        onClick={() => {
          handleOpenPrimaryFilters(true);
        }}
      >
        <div className={styles.leftWrapper}>
          <span className={styles.text}>
            {t(textTrKey, text)}
            {textSecondary && (
              <strong className={styles.secondaryText} suppressHydrationWarning>
                {textSecondary}
              </strong>
            )}
          </span>
          <p className={styles.filterWrapper}>
            {isPreferito && <Icon iconId={IconsEnum.FULL_PIN} className={styles.icon} color="var(--color-primary)" />}
            <span className={styles.filter}>{t(selectedFilterTrKey, selectedFilter)}</span>
          </p>
        </div>
        <Icon iconId={IconsEnum.CHEVRON_RIGHT} className={styles.iconSmall} color="var(--color-on-bg-primary)" />
      </button>
      {/* TODO onClick => dispatch(azione che setto lo stato di apertura del filtro ulteriore) */}
      {/* potrebbe essere dinamico */}
      {hasAdditionalFilters && (
        <button
          type="button"
          className={styles.secondaryFiltersBtn}
          onClick={() => {
            handleOpenSecondaryFilters && handleOpenSecondaryFilters(!secondaryFiltersOpen);
          }}
        >
          <Icon
            iconId={secondaryFiltersOpen ? IconsEnum.CLOSE : IconsEnum.FILTER}
            className={`${secondaryFiltersOpen ? styles.iconSmall : styles.icon}`}
            color="var(--color-on-bg-primary)"
          />
        </button>
      )}
    </div>
  );
};
